import React from "react";
import { defaultStyle } from "./style";
import { css } from "emotion";
import { Dropdown as AtomicDropdown } from "@maxmilhas/hangar-components-atomic/public";

const Dropdown = props => {
    const dropdownStyle = defaultStyle(props.withShadow, props.hasError)
    return (
        <div className={
            css`${dropdownStyle}`
        }>
            <AtomicDropdown {...props} />
        </div>
    );
};
Dropdown.displayName = "styledDropdown";

export default Dropdown;
